import React, { useEffect, useState } from 'react';

import { FormRotas } from '../../components/FormRotas';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarRotaPage(props) {

    const [pedra, setRota] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingRota, setErrorGettingRota] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idRota] = useState(props.match.params.id)


    const getRota = async (id) => {
        setIsLoading(true);

        try {
            const response = await api.get(`rotas/${id}`)

            setRota({
                'id': response.data.id,
                'nome': response.data.nome
            })

            setErrorGettingRota(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingRota(true)
        }

        setIsLoading(false);
    }

    useEffect(() => {
        getRota(idRota)
    }, [])

    return (
        <>
            <MenuMain >
                {
                    errorGettingRota ?
                        <ErrorRetrievingData
                            errorMessage={errorMessage}
                            retrieveFunction={() => getRota(idRota)}
                            isLoading={isLoading}
                        />
                        :
                        <FormRotas
                            defaultValues={pedra}
                            isEditing={true}
                            isLoading={isLoading}
                        />
                }
            </MenuMain>
            <AppFooter />
        </>
    );
}
